export function printThermalTicket(elementId: string, numeroPedido?: string) {
  const ticket = document.getElementById(elementId);
  if (!ticket) {
    console.error(`Ticket element #${elementId} not found`);
    return false;
  }
  const html = ticket.innerHTML;
  const w = window.open('', '_blank', 'width=320,height=600');
  if (!w) {
    return false;
  }
  w.document.write(`<!DOCTYPE html>
<html>
<head>
<title>Ticket ${numeroPedido || ''}</title>
<style>
@page { size: 80mm auto; margin: 0; }
body { margin: 0; padding: 3mm; font-family: 'Courier New', Courier, monospace; font-size: 10pt; line-height: 1.3; color: #000; background: white; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
.thermal-ticket { width: 72mm; max-width: 72mm; }
.ticket-header { text-align: center; margin-bottom: 2mm; }
.ticket-title { font-size: 14pt; font-weight: bold; margin: 0 0 1mm 0; letter-spacing: 0.5px; }
.ticket-subtitle { font-size: 9pt; margin: 0 0 1mm 0; }
.ticket-info { font-size: 8pt; margin: 0; line-height: 1.4; }
.ticket-divider { text-align: center; font-size: 8pt; margin: 2mm 0; letter-spacing: -1px; }
.ticket-section { margin-bottom: 1mm; }
.ticket-row { display: flex; justify-content: space-between; margin: 0.5mm 0; }
.ticket-label { font-weight: bold; }
.ticket-value { text-align: right; }
.ticket-items { margin: 2mm 0; }
.ticket-item-header { display: flex; justify-content: space-between; font-size: 8pt; font-weight: bold; border-bottom: 1px dashed #000; padding-bottom: 1mm; margin-bottom: 1mm; }
.ticket-item { margin-bottom: 1.5mm; }
.ticket-item-name { font-size: 9pt; word-wrap: break-word; }
.ticket-item-pres { font-size: 8pt; color: #333; }
.ticket-item-row { display: flex; justify-content: space-between; font-size: 9pt; }
.ticket-col-desc { flex: 1; }
.ticket-col-qty { width: 35mm; text-align: right; }
.ticket-col-total { width: 20mm; text-align: right; font-weight: bold; }
.ticket-totals { margin: 2mm 0; }
.ticket-total-row { font-size: 11pt; font-weight: bold; border-top: 1px solid #000; padding-top: 1mm; margin-top: 1mm; }
.ticket-footer { text-align: center; margin-top: 4mm; padding-top: 2mm; border-top: 1px dashed #000; }
.ticket-footer p { margin: 0.5mm 0; font-size: 9pt; }
.ticket-small { font-size: 7pt; color: #444; }
</style>
</head>
<body>
<div class="thermal-ticket">${html}</div>
</body>
</html>`);
  w.document.close();
  w.focus();
  setTimeout(() => { w.print(); }, 300);
  return true;
}
